import { MaybeString } from '../../../utils'
import { MainContentSectionLine } from './main-content-section-line'
import { MainContentSectionText } from './main-content-section-text'

interface SectionTextProps {
  id: string
  lineHeader?: string
  lineText: MaybeString
}

export interface MainContentSectionTextGroupProps {
  textItems: SectionTextProps[]
}

export const MainContentSectionTextGroup = ({
  textItems
}: MainContentSectionTextGroupProps) => {
  return (
    <>
      {textItems.map((item, index) => {
        const { id, lineHeader, lineText } = item
        return (
          <MainContentSectionLine
            key={`${id}-section-line-${index}`}
            lineHeader={lineHeader}
          >
            {lineText && (
              <MainContentSectionText id={id}>
                {lineText}
              </MainContentSectionText>
            )}
          </MainContentSectionLine>
        )
      })}
    </>
  )
}
